import { useState } from 'react'

import { useComponenteDeCreditoMutation } from '@/hooks/mutations/use-componente-de-credito-mutation'
import { IUser } from '@/interfaces/user'

export function useCreditoModal(userData: IUser) {
  const [isConfirmarCreditoModalOpen, setIsConfirmarCreditoModalOpen] = useState(false)
  const [isResultadoModalOpen, setIsResultadoModalOpen] = useState(false)
  const [resultadoModalData, setResultadoModalData] = useState<any>(null)
  const [isResultadoModalLoading, setIsResultadoModalLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedId, setSelectedId] = useState<string>('')

  const { mutateAsync: submeterPedidoMutate } = useComponenteDeCreditoMutation()

  const handleOpenConfirmarCredito = (id: string) => {
    setSelectedId(id)
    setIsConfirmarCreditoModalOpen(true)
  }

  const submeterPedidoAAprovacao = async (pedidoVendaId: string) => {
    setIsLoading(true)
    setIsConfirmarCreditoModalOpen(false)
    setIsResultadoModalLoading(true)
    setIsResultadoModalOpen(true)

    try {
      const result = await submeterPedidoMutate({
        idPedido: pedidoVendaId,
        idUsuario: userData?.userId ?? '',
        nomeUsuario: userData?.userName ?? ''
      })
      setResultadoModalData(result)
    } catch {
      setResultadoModalData({ sucesso: false, conteudo: { erro: true } })
    } finally {
      setIsLoading(false)
      setIsResultadoModalLoading(false)
    }
  }

  return {
    isConfirmarCreditoModalOpen,
    setIsConfirmarCreditoModalOpen,
    isResultadoModalOpen,
    setIsResultadoModalOpen,
    resultadoModalData,
    setResultadoModalData,
    isResultadoModalLoading,
    isLoading,
    selectedId,
    handleOpenConfirmarCredito,
    submeterPedidoAAprovacao
  }
}